import GridContainer from './GridContainer'

export default GridContainer
